import React from 'react';
import {
  Collapse,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  Switch,
  InputAdornment,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import FormikTextField from '../../Common/Formik/FormikTextField';
import Grid from '@mui/material/Unstable_Grid2';
import { useAuth } from '../../../Contexts/AuthContext';
import { TICKET_TYPES } from '../../../Utils/ticketUtils';
const useStyles = makeStyles((theme) => ({
  radioGroupLabel: {
    marginBottom: theme.spacing(1),
  },
}));
const TicketTypeSelector = ({ formik, currency, disabled, isNew }) => {
  const classes = useStyles();
  const { isAdmin } = useAuth();

  const isMembership = formik.values.ticketType === TICKET_TYPES.MEMBERSHIP;

  const showMembershipOption = isAdmin || (isNew ? false : (isMembership));

  return (
    <React.Fragment>
      <Grid xs={12}>
        <FormControl
          required
          component="fieldset"
          error={formik.touched.ticketType && Boolean(formik.errors.ticketType)}
        >
          <FormLabel component="legend" className={classes.radioGroupLabel}>
            Ticket type
          </FormLabel>
          <RadioGroup
            value={formik.values.ticketType ?? TICKET_TYPES.REGULAR}
            name="ticketType"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
          >
            <FormControlLabel
              value={TICKET_TYPES.REGULAR}
              control={<Radio />}
              label="Regular ticket"
              disabled={disabled}
            />
            <FormControlLabel
              value={TICKET_TYPES.TEAM}
              control={<Radio />}
              label="Team/Corporate/Relay Ticket"
              disabled={disabled}
            />
            {showMembershipOption && (
              <FormControlLabel
                value={TICKET_TYPES.MEMBERSHIP}
                control={<Radio />}
                label="Membership ticket"
                disabled={disabled || !isAdmin}
              />
            )}
          </RadioGroup>
          {formik.touched.ticketType && formik.errors.ticketType && (
            <FormHelperText>{formik.errors.ticketType}</FormHelperText>
          )}
        </FormControl>
      </Grid>

      <Collapse in={formik.values.ticketType === TICKET_TYPES.TEAM}>
        <Grid container spacing={2}>
          <Grid xs={6}>
            <FormikTextField
              name="minParticipantCount"
              label="Min participants"
              helperText="The minimum number of team members"
              required
              disabled={disabled}
            />
          </Grid>
          <Grid xs={6}>
            <FormikTextField
              name="numParticipantsIncluded"
              label="Max participants"
              helperText="The maximum number of team members included in the price of this ticket"
              required
              disabled={disabled}
            />
          </Grid>
          <Grid xs={12}>
            <FormGroup>
              <FormControlLabel
                label="Allow additional team members at extra cost"
                control={
                  <Switch
                    color="primary"
                    name="additionalTickets"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    checked={formik.values.additionalTickets ?? false}
                    disabled={disabled}
                  />
                }
              />
            </FormGroup>
          </Grid>
          {formik.values.additionalTickets && (
            <Grid xs={6}>
              <FormikTextField
                name="additionalTeamMemberPrice"
                label="Additional cost"
                helperText="Cost for each additional team member"
                required
                disabled={disabled}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>{currency?.toUpperCase()}</InputAdornment>
                  ),
                }}
              />
            </Grid>
          )}
        </Grid>
      </Collapse>
    </React.Fragment>
  );
};

export default TicketTypeSelector;
